<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    <multiselect v-model="selected" :custom-label="getLabel" :track-by="field" :placeholder="placeHolder" :disabled="disabled"
                 :options="items" :multiple="multiple"
                 @input="onInput" @search-change="search">
      <template v-slot:noResult>
        {{ $t('notFoundSearch') }}
      </template>
      <template v-slot:noOptions>
        {{ $t('notFoundSearch') }}
      </template>
    </multiselect>
  </b-form-group>
</template>

<script>
import list from '../mixins/List';
import _ from "lodash";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  props: {
    model: Object,
    clientFilter: String,
    attribute: {
      type: String,
      default: 'group'
    },
    label: String,
    errors: Array,
    placeHolder: {
      type: String,
      default: 'Select group'
    },
    multiple: Boolean,
    groupFilter: String,
    groupsFilter: Array,
    field: {
      type: String,
      default: "_id"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mixins: [list],
  components: {Multiselect},
  data() {
    return {
      selected: null,
      state: null,
      errorTxt: '',
      options: [],
      showList: false,
      service: 'client-user-group',
      autoLoad: false,
      afterLoad: function () {
        this.items.unshift({_id: 'default', name: this.$t('default'), ext: '0000'});
      },
      defaultFilterFormModel: {
        client: this.clientFilter,
        keyword: '',
        status: 0
      },
      focused: false,
      changeTrigger: true,
      client: this.clientFilter
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        if (val.client !== this.client) {
          this.filterFormModel.client = val.client;
          this.client = val.client;
          this.selected = this.multiple ? [] : null;
          this.model[this.attribute] = this.multiple ? [] : null;
          this.load();
        }
        if ((!this.multiple && val[this.attribute] != null) || (this.multiple && val[this.attribute] && val[this.attribute].length)) {
          if (this.changeTrigger) {
            this.loadSelected();
          }
          this.changeTrigger = true;
        } else {
          this.selected = null;
        }
      }, deep: true
    },
    selected(val) {
      this.changeTrigger = false;
      if (val === null) {
        this.model[this.attribute] = this.multiple ? [] : val;
      } else if (this.multiple) {
        this.model[this.attribute] = val.map(s => s[this.field]);
      } else {
        this.model[this.attribute] = val[this.field];
      }
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  methods: {
    onInput() {
      let val = this.selected;
      this.changeTrigger = false;
      if (val === null) {
        this.model[this.attribute] = val;
      } else if (this.multiple) {
        this.model[this.attribute] = val.map(s => s[this.field]);
      } else {
        this.model[this.attribute] = val[this.field];
      }
      this.$emit('change');
    },
    getLabel({name, ext}) {
      return `${name} - ${ext}`;
    },
    search: _.debounce(function (event) {
      this.filterFormModel.keyword = event;
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    loadSelected() {
      if ((!this.multiple && this.model[this.attribute]) || (this.multiple && this.model[this.attribute] && this.model[this.attribute].length)) {
        let fields;
        if (this.multiple) {
          fields = this.model[this.attribute].join(',');
        } else {
          fields = this.model[this.attribute];
        }
        this.$bgService.get('/client-user-group', {
          params: {
            page: 1,
            pageSize: 200,
            field: this.field,
            fields: fields,
            client: this.client
          }
        }).then(response => {
          if (this.multiple) {
            this.selected = response.data.docs;
          } else if (response.data.docs.length) {
            this.selected = response.data.docs[0];
          }
        });
      }
    }
  },
  mounted() {
    this.selected = null;
    this.loadSelected();
    this.search();
  },
  i18n: {
    messages: {
      vi: {
        default: "Mặc định"
      },
      en: {
        default: "Default"
      }
    }
  }
}
</script>